import React from "react";
import RevealText from "../Comman/RevealText";

export default function Introduction() {
  return (
    <>
      <div
        className="tp-hero-3-area tp-hero-3-ptb fix"
        style={{ backgroundImage: "url(assets/img/one/hero_bg.png)" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-xl-12">
              <div className="tp-hero-3-content-box text-center p-relative">
                <RevealText text="Privacy Policy – Kryptogram NFTs" />
                {/* <span className="tp-hero-3-category tp_reveal_anim">
                  Welcome to Kryptogram. We respect your privacy and are
                  committed to protecting your personal information. This
                  Privacy Policy outlines how we collect, use, and safeguard
                  data related to your use of our NFT marketplace, Kryptogram
                  Island land ownership program, and Tribe O Crypto Festival
                  services.
                </span>
                <span className="tp-hero-3-category tp_reveal_anim">
                  By using our website and purchasing Kryptogram NFTs, you agree
                  to the collection, processing, and use of your data as
                  described in this policy.
                </span> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
